module.exports = {"apiBaseUrl":"localhost:3000/"}


//////////////////
// WEBPACK FOOTER
// ./src/lib/config/config.production.json
// module id = WVLx
// module chunks = 1